import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'
import React, {Suspense, useMemo} from 'react'

import type {Tariff, TariffsZone} from '../../../../../../api'
import {ErrorBoundary} from '../../../../../../components/ErrorBoundary'
import {Loader, Paper} from '../../../../../../components/ui'
import {useConfig} from '../../../../../../config'
import type {PathWithCountry} from '../../../../../../types'
import {Resource} from '../../../../../../utils'
import {NddDownloadButtonContainer} from '../../components/DownloadButton/NddDownloadButton.container'
import styleClasses from './classes.module.css'
import {NddInfo} from './NddInfo'

export type Props = {
  city: TariffsZone
  tariff: Tariff
  path: PathWithCountry
}

export function NddInfoContainer(props: Props) {
  const {city, path, tariff} = props
  const {tariffsService} = useConfig()

  const resource = useMemo(
    () => new Resource(() => tariffsService.fetchNddInfo(path.country, city.id, tariff.id)),
    [city.id, path.country, tariff.id, tariffsService],
  )

  const i18n = useI18n()

  return (
    <div className={styleClasses.cargoInfoContainer}>
      <Paper className={styleClasses.infoHeader}>
        <Typography density="tight" level="title2" weight="bold">
          {i18n('tariffs-v3.tariff-info.title', {
            placeholder: {
              tariffTitle: tariff.title,
              cityTitle: city.title,
            },
          })}
        </Typography>
        <NddDownloadButtonContainer country={path.country} tariff={tariff.id} />
      </Paper>

      <div className={styleClasses.contentWrapper}>
        <ErrorBoundary>
          <Suspense fallback={<Loader />}>
            <NddInfo country={path.country} resource={resource} tariff={tariff.id} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  )
}
